import React from 'react';
import BenchmarkBadge from '../../Marketing/BenchmarkBadge';
import useReveal from '../useReveal';
import './AIEProofSection.css';

/**
 * AIEProofSection — "Don't take the word. Take the receipts."
 * Two receipts only (mock ruling #3, Aug 5): the dated benchmark (via the
 * shared BenchmarkBadge, which stays canon-compliant: dated + linked) and
 * real customer quotes.
 *
 * QUOTES are drawn verbatim from the SANCTIONED public pool
 * (SuperAgents/sections/SATestimonials.js — real, previously-shipped quotes).
 * Do NOT add invented quotes or edit wording; attribution style (flag +
 * country) matches the shipped precedent.
 */
const QUOTES = [
  { quote: 'I tried AlphaSense, then used CellCog. So much better — surprised AlphaSense couldn’t do it.', flag: '🇺🇸', country: 'United States' },
  { quote: 'Ran the same prompt on Claude and CellCog. Claude: 7/10. CellCog: 8.5/10.', flag: '🇮🇳', country: 'India' },
  { quote: 'It’s like having an entire research team at your fingertips.', flag: '🇺🇸', country: 'United States' },
];

const AIEProofSection = () => {
  const [ref, visible] = useReveal();

  return (
    <section className="aie-proofs aie-section" ref={ref}>
      <div className="aie-section-head">
        <span className="aie-eyebrow">Proof</span>
        <h2 className="aie-section-title aie-display">
          Don&rsquo;t take the word. Take the receipts.
        </h2>
      </div>
      <div className={`aie-reveal ${visible ? 'is-visible' : ''}`}>
        <div className="aie-proofs__badge">
          <BenchmarkBadge page="ai-employees" location="proof" />
        </div>
        <p className="aie-proofs__note">
          The engine inside every AI employee, measured against the field.
        </p>
        <div className="aie-proofs__quotes">
          {QUOTES.map((t) => (
            <figure className="aie-proofs__card" key={t.country + t.quote.slice(0, 12)}>
              <blockquote className="aie-proofs__quote">&ldquo;{t.quote}&rdquo;</blockquote>
              <figcaption className="aie-proofs__src">
                <span aria-hidden="true">{t.flag}</span>
                {t.country}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIEProofSection;
